export function DiamondFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M3.414 10.586l7.172-7.172a2 2 0 012.828 0l7.172 7.172a2 2 0 010 2.828l-7.172 7.172a2 2 0 01-2.828 0l-7.172-7.172a2 2 0 010-2.828z"
      ></path>
    </svg>
  );
}
